<template>
  <Mobile :is-opened="$attrs.show">
    <KwTransition name="appear-y">
      <KwMobilePanelMenu v-if="$attrs.show" bg-color="#ffffff">
        <CabinetContainer>
          <ViewContainer>
            <div class="mobile-menu pl_lg pr_lg">
              <div class="mobile-menu__block pt_lg pb_xxl">
                <div class="mobile-menu__item">
                  <span @click="goToMain">{{ i18n('book_transfer_menu__button') }}</span>
                </div>
              </div>

              <div class="mobile-menu__block pt_xxl pb_xxl">
                <div class="mobile-menu__item pb_xl">
                  <span @click="() => changeRoute('bookings')">
                    {{ i18n('my_bookings_menu__button') }}
                  </span>
                </div>
                <div class="mobile-menu__item pb_xl">
                  <span @click="() => changeRoute('extraPayments')">
                    {{ i18n('my_extra_payments_menu__button') }}
                  </span>
                </div>
                <div class="mobile-menu__item pb_xl">
                  <span @click="() => changeRoute('profile')">
                    {{ i18n('my_profile_menu__button') }}
                  </span>
                </div>
                <div class="mobile-menu__item pb_xl">
                  <span @click="() => changeRoute('balance')">
                    {{ i18n('my_balance_menu__button') }}
                  </span>
                </div>
                <!-- <div class="mobile-menu__item pb_xl">
                  <span>{{ i18n('help_menu__button') }}</span>
                </div> -->
                <div class="mobile-menu__item">
                  <span @click="logOut">{{ i18n('log_out_menu__button') }}</span>
                </div>
              </div>

              <div class="mobile-menu__block pt_xxl pb_xxl">
                <div class="mobile-menu__item">
                  <Balance @close='emitClose'/>
                </div>
                <div class="mobile-menu__item">
                  <KwSelect
                    v-model='currentLang'
                    :options="languages"
                  />
                </div>
              </div>
            </div>
            </ViewContainer>
          </CabinetContainer>
        </KwMobilePanelMenu>
    </KwTransition>
  </Mobile>
</template>

<script>
import KwSelect from '@kiwitaxi/vue-components/dist/KwSelect';
import { i18n, locations } from '@/mixins';
import { changeLocale } from '@/assets/js/utils/browser';
import { LOGOUT } from '@/services/AuthService';
import { LANGUAGES } from '@/utils/Constants';
import KwTransition from '@/components/KwTransition.vue';
import KwMobilePanelMenu from '@/components/KwMobilePanelMenu.vue';
import CabinetContainer from '@/components/CabinetContainer.vue';
import ViewContainer from '@/components/ViewContainer.vue';
import Balance from './Balance.vue';

import Mobile from '../Mobile.vue';

export default {
  name: 'MobileMenu',
  mixins: [i18n, locations],
  components: {
    KwSelect,
    Mobile,
    KwTransition,
    KwMobilePanelMenu,
    CabinetContainer,
    ViewContainer,
    Balance,
  },
  computed: {
    languages() {
      if (this.currentLang === 'ru') {
        return LANGUAGES.filter(language => language.value === 'ru');
      }

      return LANGUAGES.filter(language => language.value !== 'ru');
    },
    currentLang: {
      get() {
        return this.$store.getters.lang;
      },
      set(value) {
        changeLocale(value);
      },
    },
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    changeRoute(name) {
      this.emitClose();
      this.$nextTick(() => this.$router.push({ name }));
    },
    logOut() {
      if (window.IntercomBootstrap) window.IntercomBootstrap.reset();
      if (window.TalkMeBootstrap) window.TalkMeBootstrap.reset();
      this.locationReplace(LOGOUT);
    },
    goToMain() {
      this.locationReplace(window.location.origin);
    },
  },
};
</script>


<style lang="scss" scoped>
  .mobile-menu {
    &__block {
      &:not(:last-child) {
        border-bottom: 1px solid $base-lightest;
      }
      .kw-dropdown {
        max-width: 164px;
      }
    }
    &__item {
      > span {
        cursor: pointer;
      }
    }
  }

  .balance {
    display: inline-block;
    font-size: 100%;
    margin-bottom: 1rem;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/components/MobileMenu.vue